import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { textAnalyzerService, Draft, AnalysisPayload, AnalysisResult } from '@/services/textAnalyzerService';
import { useAuth } from '@/features/auth/context/AuthContext';
import { useParams } from 'react-router-dom';



export const useTokens = (enabled: boolean = true) => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['tokens', user?.uid],
    queryFn: () => textAnalyzerService.getTokens(user!.uid),
    enabled: enabled && !!user?.uid,
  });
};

export const useAnalyzeEssay = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: (payload: AnalysisPayload) => textAnalyzerService.analyzeEssay(payload),
    onSuccess: () => {
      // Invalidate drafts query to refresh the list
      queryClient.invalidateQueries({ queryKey: ['drafts'] });
    },
  });
};

export const useSaveDraft = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (draft: Omit<Draft, 'draft_id'>) => textAnalyzerService.saveDraft(draft),
    onSuccess: () => {
      // Invalidate drafts query to refresh the list
      queryClient.invalidateQueries({ queryKey: ['drafts'] });
    },
  });
};

export const useUpdateTokens = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: (userId: string) => textAnalyzerService.updateTokens(userId),
    onSuccess: () => {
      // Invalidate tokens query to refresh the count
      queryClient.invalidateQueries({ queryKey: ['tokens'] });
    },
  });
}; 